import { axiosObject } from "../config";

export default function googleLoginWithToken(payload: any) {
    return new Promise((resolve, reject) => {
        let uri = "access/login/google-with-token";
        axiosObject
            .get(uri, { params: payload })
            .then(async (response) => {
                resolve(response.data);
            })
            .catch((errors) => {
                reject(errors);
            });
    });
}
